// extracted by mini-css-extract-plugin
export var active = "_aw-d";
export var blink = "_aw-e";
export var container = "_aw-5";
export var controls = "_aw-0";
export var controlsRight = "_aw-1";
export var fakeCursor = "_aw-c";
export var hidden = "_aw-b";
export var quillContainerSmall = "_aw-7";
export var quillEditor = "_aw-6";
export var quillEditorSmall = "_aw-8";
export var quillFormatButtons = "_aw-a";
export var quillToolbar = "_aw-9";
export var removePadding = "_aw-2";
export var state = "_aw-3";
export var stateTitle = "_aw-4";